export const ModulesMessages = {
    HOME_MODULE: 'Home',

    // MODULES
    MODULES_MODULE: 'Módulos',
    ACCOUNTS_PAGE: 'Cuentas',
    PQR_PAGE: 'Casos PQR',
    PQR_HISTORY_PAGE: 'Casos históricos PQR',
    INITIAL_CAUSALITY_PAGE: 'Causalidad inicial',
    GENERAL_PAGE: 'Casos información generales',
    SARLAFT_PAGE: 'Casos SARLAFT',
    SEARCH_CASE_PAGE: 'Búsqueda de casos',
    CASES_PAGE: 'Búsqueda de casos general',
    MODULES_PQR_MANAGEMENT: 'Gestión PQR',
    LEGAL_PROCEEDING: 'Procesos Judiciales',
    ALERTS_MODULE: 'Alertas PQR',
    SAMPLES_MODULE: 'Muestras PQR',
    EXPORT_MODULE: 'Exportar',
    REDIRECT_MODULE: 'Redirección PQR',
    REDIRECT_PERSON_PAGE: 'Maestro de personas',
    REDIRECT_AREA_PAGE: 'Maestro de áreas',
    MODULES_TYPIFICATIONS: 'Tipificaciones',
    FINAL_CAUSALITY_MODULE: 'Causalidad Final',
    USERS_MODULE: 'Usuarios',
    SYSTEM_CONFIGURATION_MODULE: 'Configuración del Sistema',
    MOTIVE_PAGE: 'Motivos',
    SUBMOTIVE1_PAGE: 'Submotivo 1',
    SUBMOTIVE2_PAGE: 'Submotivo 2',
    SUBMOTIVE3_PAGE: 'Submotivo 3',
    SUBMOTIVE4_PAGE: 'Submotivo 4',
    PROCEDURE_PAGE: 'Trámite PQR',
    PQR_TYPE_PAGE: 'Módulo Tipo PQR',
    SUBTYPE_DP_PAGE: 'Módulo Subtipo DP',
    SWITCH_PAGE: 'Conmutador',
    QUOTATION_PAGE: 'Cotización',
    PQR_RECPETION_CHANNEL_PAGE: 'Canales de recepción PQR',
    PQR_RECEIVED_THROUGH_PAGE: 'Medio PQR',
    PRODUCT_PAGE: 'Productos',
    FRAUD_MODE_PAGE: 'Modalidad fraude',
    FRAUD_TYPE_PAGE: 'Tipología fraude',
    PQR_STATUS_PAGE: 'Módulo Estados PQR',
    FUNCTIONARIES_SWITCHBOARD_PAGE: 'Funcionarios Conmutador',
    COMPLIANCE_TERMS_PAGE: 'Cumplimiento de términos',
    SURVEYS_PAGE: 'Encuestas',
    SURVEY_RESPONSES_PAGE: 'Respuestas de Encuestas',
    ORBIT_MODULE: 'Orbit',
    ORBIT_RADICATION_PAGE: 'Radicación Orbit',
    ORBIT_HISTORY_PAGE: 'Histórico Orbit',
    ORBIT_DETAIL_PAGE: 'Detalle caso Orbit',
};
